import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('calling-remote-app');
export const OPEN_REMOTE = 'open-remote';